import {
  CREATE_ASSEMBLY_GROUPS_DIALOG,
  CREATE_TRAILER_DIALOG,
  CREATE_TRUCK_DRIVER_DIALOG,
  CreateAssemblyGroupsDialogProps,
  EDIT_ASSEMBLY_GROUP_PROPERTIES_DIALOG,
  EDIT_DIRECTORY_DIALOG,
  EDIT_LINE_DIALOG,
  EDIT_STATION_DIALOG,
  EditAssemblyGroupPropertiesDialogProps,
  EditDirectoryDialogProps,
  EditLineDialogProps,
  EditStationDialogProps,
  PERMANENT_LINKS_DIALOG,
  PermanentLinksDialogProps as PermanentLinksDialogProps,
  SEND_ASSEMBLY_GROUP_DIALOG,
  SendAssemblyGroupDialogProps,
  STATION_INSERTION_DIALOG,
  StationInsertionDialogProps,
} from '../components/dialogs/dialogs';
import { showPopup } from '../store/popupSlice';

export interface PopupOptionsMap {
  [EDIT_DIRECTORY_DIALOG]: EditDirectoryDialogProps;
  [EDIT_LINE_DIALOG]: EditLineDialogProps;
  [EDIT_STATION_DIALOG]: EditStationDialogProps;
  [PERMANENT_LINKS_DIALOG]: PermanentLinksDialogProps;
  [STATION_INSERTION_DIALOG]: StationInsertionDialogProps;
  [CREATE_TRAILER_DIALOG]: undefined;
  [CREATE_TRUCK_DRIVER_DIALOG]: undefined;
  [CREATE_ASSEMBLY_GROUPS_DIALOG]: CreateAssemblyGroupsDialogProps;
  [SEND_ASSEMBLY_GROUP_DIALOG]: SendAssemblyGroupDialogProps;
  [EDIT_ASSEMBLY_GROUP_PROPERTIES_DIALOG]: EditAssemblyGroupPropertiesDialogProps;
}

export function showCreateDirectoryDialog(parentGuid?: string) {
  const props: EditDirectoryDialogProps = { mode: 'create', parentGuid };
  return showPopup(EDIT_DIRECTORY_DIALOG, props);
}

export function showEditDirectoryDialog(directoryGuid: string) {
  const props: EditDirectoryDialogProps = { mode: 'edit', directoryGuid };
  return showPopup(EDIT_DIRECTORY_DIALOG, props);
}

export function showCreateLineDialog(parentGuid?: string) {
  const props: EditLineDialogProps = { mode: 'create', parentGuid };
  return showPopup(EDIT_LINE_DIALOG, props);
}

export function showEditLineDialog(lineGuid: string) {
  const props: EditLineDialogProps = { mode: 'edit', lineGuid };
  return showPopup(EDIT_LINE_DIALOG, props);
}

export function showCreateStationDialog(lineGuid?: string) {
  const props: EditStationDialogProps = { mode: 'create', lineGuid };
  return showPopup(EDIT_STATION_DIALOG, props);
}

export function showEditStationDialog(stationGuid: string) {
  const props: EditStationDialogProps = { mode: 'edit', stationGuid };
  return showPopup(EDIT_STATION_DIALOG, props);
}

export function showPermanentLinksDialog(stationGuid: string) {
  const props: PermanentLinksDialogProps = { stationGuid };
  return showPopup(PERMANENT_LINKS_DIALOG, props);
}

export function showStationInsertionDialog(stationGuid: string, defaultLineGuid?: string) {
  const props: StationInsertionDialogProps = { stationGuid, defaultLineGuid };
  return showPopup(STATION_INSERTION_DIALOG, props);
}

export function showCreateTrailerDialog() {
  return showPopup(CREATE_TRAILER_DIALOG);
}

export function showCreateTruckDriverDialog() {
  return showPopup(CREATE_TRUCK_DRIVER_DIALOG);
}

export function showCreateAssemblyGroupDialog(initialLookupCode?: string) {
  return showPopup(CREATE_ASSEMBLY_GROUPS_DIALOG, { initialLookupCode });
}

export function showSendAssemblyGroupDialog(assemblyGroupGuid: string) {
  return showPopup(SEND_ASSEMBLY_GROUP_DIALOG, { assemblyGroupGuid });
}

export function showEditAssemblyGroupPropertiesDialog(assemblyGroupGuid: string) {
  return showPopup(EDIT_ASSEMBLY_GROUP_PROPERTIES_DIALOG, { assemblyGroupGuid });
}
